export const Route = 'Organisation/RequestTracker/';
export const SearchOrganisationRequests = Route + "Search";
export const RequestEmployees = Route + 'RequestEmployees/';
export const LatestRequest = Route + 'LatestRequest/';
export const ValidationReview = Route + 'ValidationReview/';
export const TriggerDryRun = Route + 'TriggerDryRun/';

export const ImportFile = Route + 'ImportFile/';
export const StagedData = Route + 'StagedData/';
